import type { TextStreamEvent } from './chat-api.service';
import type { Citation, SuggestedCTA, UnifiedSearchApiResponse } from './types';

export interface TextStreamHandlers {
  onTextChunk: (accumulated: string) => void;
  onMetadata: (metadata: {
    citations?: Citation[];
    suggestedCTA?: SuggestedCTA | null;
    nonDefinedCTA?: { label: string; url: string } | null;
  }) => void;
  onResponse: (data: UnifiedSearchApiResponse) => void;
}

export async function consumeTextStreamEvents(
  stream: AsyncGenerator<TextStreamEvent>,
  handlers: TextStreamHandlers
): Promise<void> {
  let accumulated = '';

  for await (const event of stream) {
    if (event.type === 'text') {
      accumulated += event.chunk;
      handlers.onTextChunk(accumulated);
    } else if (event.type === 'metadata') {
      handlers.onMetadata({
        citations: event.citations,
        suggestedCTA: event.suggestedCTA,
        nonDefinedCTA: event.nonDefinedCTA,
      });
    } else if (event.type === 'response') {
      handlers.onResponse(event.data);
    }
  }
}
